import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/navigation';

Vue.component('block-slider', {
    props: {
        customClassBlockSlider: {
            type: String,
            required: false,
        },
        data: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            swiper: null,
        };
    },

    async mounted() {
        this.timeout = setTimeout(async () => {
            await this.initSwiper();
        }, 400);
    },

    methods: {
        async initSwiper() {
            if (this.swiper) {
                // Update the existing swiper instance
                this.swiper.updateSlides();
                this.swiper.updateSize();
                this.swiper.updateProgress();
                this.swiper.updateSlidesClasses();

                // Force scrollbar update
                this.swiper.scrollbar.updateSize();
                this.swiper.scrollbar.init();
                this.swiper.scrollbar.setTranslate();

                // Force navigation update
                if (this.swiper.navigation) {
                    this.swiper.navigation.update();
                }
                this.swiper.update();
            } else {
                const { Swiper } = await getSwiper();
                const {
                    Autoplay,
                    Scrollbar,
                    Navigation,
                    Pagination,
                    A11y,
                    Keyboard,
                } = await getSwiperModules();

                const slider = this.$el.querySelector(
                    this.customClassBlockSlider ?? '.block-slider__slider',
                );

                const swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    centeredSlides: false,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    modules: [
                        Scrollbar,
                        Navigation,
                        Keyboard,
                        A11y,
                        Autoplay,
                        Pagination,
                    ],
                    keyboard: {
                        enabled: true,
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        hide: false,
                        draggable: true,
                    },
                    uniqueNavElements: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                }).on('transitionEnd', () => {
                    if (
                        this.$el.querySelectorAll('.swiper-slide-active video')
                            .length > 0
                    ) {
                        this.$el.querySelectorAll(
                            '.swiper-slide-active video',
                        )[0].currentTime = 0;
                        this.$el
                            .querySelectorAll('.swiper-slide-active video')[0]
                            .play();
                    }
                });

                // Create new swiper instance
                this.swiper = swiper;

                // Add a slight delay to allow DOM to render properly before updating scrollbar
                Vue.nextTick(() => {
                    if (!this.swiper || !this.swiper.scrollbar) return;

                    this.swiper.scrollbar.updateSize();
                    this.swiper.scrollbar.setTranslate();
                });
            }
        },

        autoplayVideo() {
            const firstVideo = this.$el.querySelector(
                '.swiper-slide-active video',
            );
            if (firstVideo) {
                firstVideo.play();
            }

            const allVideos = this.$el.querySelectorAll('.swiper-slide video');
            allVideos.forEach((element) => {
                element.addEventListener('ended', this.nextSlide);
            });
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        destroySwiper() {
            this.swiper.destroy();
            this.swiper = null;
        },
    },
});
